import { JSX } from 'react';
import { GetArticleBaseModel } from 'src/shared/ArticleBase.service';
import { Article } from '@ahc-digital/component-library';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C51BlogDetailsProps } from './C61BlogDetails.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { useUpdateEmailShareLink } from 'src/shared/useUpdateEmailShareLink';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C51BlogDetailsProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const headline = props?.rendering?.fields?.Headline?.value ?? '';
  useUpdateEmailShareLink(headline);

  return (
    <Article
      {...GetArticleBaseModel(props?.fields, context?.socialMediaLinks?.value ?? [])}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      imageStyle="floatRight"
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C51BlogDetailsProps>(Default);
